import React, { useContext } from 'react';
import { Box, Image, Media, Optional, Row as DsRow } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';

import HeaderContext from './service/HeaderContext';
import HeaderMobileButton from './shared/HeaderMobileButton';
import RoutableSitecoreLink from '../RoutableSitecoreLink';
import SecondaryNav from './shared/SecondaryNav';
import themeStyles from './styles/Header.styles';
import { Main } from './Menu';

const Row = themeStyles.apply(DsRow, 'Row');
const Column = themeStyles.apply(Box, 'Column');
const MainColumn = themeStyles.apply(Box, 'Column');
const SecondaryColumn = themeStyles.apply(Box, 'Column');
const MobileRightNav = themeStyles.apply(Box, 'Column');
const Logo = themeStyles.apply(Box, 'Logo');

const DefaultHeaderRow = () => {
  const { t } = useTranslation();
  const { isOpenMenu, showSecondaryMenuOnTop, styles, siteLogo } = useContext(HeaderContext);

  return (
    <Row>
      <Column {...styles.logoColumn({ isOpenMenu })}>
        <HeaderMobileButton />
        <Logo
          as={RoutableSitecoreLink}
          field={siteLogo?.headerUrl}
          data-testid="header-logo"
          aria-label={t('Shared.Header.siteLogoAria')}
          {...styles.logo}
        >
          <Image {...siteLogo?.siteLogo} />
        </Logo>
      </Column>

      <MainColumn {...styles.mainColumn} data-testid="header-top-navigation-menu">
        <Optional when={showSecondaryMenuOnTop}>
          <Box textAlign="right" mb="m" display="flex" justifyContent="end">
            <SecondaryNav />
          </Box>
        </Optional>
        <Main />
      </MainColumn>
      <Optional when={!showSecondaryMenuOnTop}>
        <Media greaterThanOrEqual="desktop">
          {className => (
            <SecondaryColumn className={className} ml="auto">
              <SecondaryNav />
            </SecondaryColumn>
          )}
        </Media>
      </Optional>
      <Media lessThan="desktop">
        {className => (
          <MobileRightNav className={className}>
            <SecondaryNav />
          </MobileRightNav>
        )}
      </Media>
    </Row>
  );
};

export default DefaultHeaderRow;
